import React from "react";
import { socialData } from "../data";

import "./Socials.css";

const Socials = () => {
  return (
    <div className="flex gap-x-[10px]">
      {socialData?.map((item, index) => {
        return (
          <a
            className="social-icon-container border border-white/20 rounded-full w-[35px] h-[35px] flex justify-center items-center text-sm hover:text-red-300 hover:border-red-300 transition-all"
            key={index}
            href={item?.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item?.icon}
          </a>
        );
      })}
    </div>
  );
};

export default Socials;
